import React from 'react'
import FeaturedItems from '../FeaturedItemSection/FeaturedItems'
import FeaturedProductSlider from './FeaturedProductsSlider'

const FeaturedProductsContainer = ({ containerObject, templateName, contentId, dataZone }) => {

  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row mt-2 `} >

      {containerObject && containerObject.attributes && containerObject.attributes.showInSlider == "true" ?
        <FeaturedProductSlider containerObject={containerObject} />
        :
        <FeaturedItems containerObject={containerObject} />
      }
     
    </div>
  )
}
export default FeaturedProductsContainer